module.exports = __webpack_public_path__ + "static/media/5.92947ce9.jpg";